import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';

/** Altera a família de modelo preferida pela empresa no Motor Fiscal. */
@Injectable({ providedIn: 'root' })
export class FormulaModeloEmpresaService extends CommonService {
    private readonly apiUrl = environment.urlApiMotorFiscal + 'FormulaModeloEmpresa';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public alterar(chaveFormula: string, chaveFormulaModelo: string | null): Observable<ReturnStruct> {
        return this.httpClient.put<ReturnStruct>(this.apiUrl, { chaveFormula, chaveFormulaModelo }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
